export const TEXTS = {
  TITLE: 'Корректная работа в личном кабинете через Сбер ID',
  INTRO:
    'Регистрация/авторизация в личном кабинете через Сбер ID может работать нестабильно в иностранных браузерах из-за отзыва зарубежных сертификатов безопасности.',
  CHOOSE_VARIANT: 'Выберите один из вариантов:',
  VARIANT_1_TITLE: 'Вариант 1',
  VARIANT_1_ITEM_1_BEFORE: 'Установите ',
  VARIANT_1_ITEM_1_LINK: 'Яндекс Браузер',
  VARIANT_1_ITEM_1_AFTER: ' — в нём уже встроены российские сертификаты безопасности',
  VARIANT_1_ITEM_2: 'Работайте с личным кабинетом через него',
  VARIANT_2_TITLE: 'Вариант 2',
  VARIANT_2_ITEM_1_BEFORE: 'Установите ',
  VARIANT_2_ITEM_1_LINK: 'сертификаты Минцифры',
  VARIANT_2_ITEM_1_AFTER: ' на своё устройство по инструкции',
  VARIANT_2_ITEM_2: 'Продолжайте работать с личным кабинетом в привычном браузере',
  CONFIRM: 'Понятно',
};
